import React, { useEffect } from 'react'
import { ToastContainer, toast } from 'react-toastify'
import Skeleton from 'react-loading-skeleton'
import { Title } from 'utils/Title'
import PageMainHeader from 'components/PageMainHeader'
import { AuthContext } from "contexts/AuthContext"
import { SettingsContext } from 'contexts/SettingsContext'
import Banner from '@leafygreen-ui/banner'
import PageMenuHeader from 'components/PageMenuHeader'
import _ from "lodash";
import { jsonToCSV } from "react-papaparse";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { errorHandler } from 'utils/errorHandler'
import IconButton from '@leafygreen-ui/icon-button'
import {Table , TableHeader, Row, Cell} from "@leafygreen-ui/table"
import MenuHeaderTemplate from 'components/MenuHeaderTemplate'
import { FaCheck, FaEdit, FaSnowplow } from 'react-icons/fa'
import ModalBin from 'components/modals/ModalBin'
import { ModalPreloader } from 'utils/Preloader'
import Button from "@leafygreen-ui/button"
import ScrollTop from 'utils/ScrollTop'
import Badge from '@leafygreen-ui/badge';
import { getBins, resetBins } from 'utils/bins'
import axios from 'axios'
import { Option, Select } from "@leafygreen-ui/select";

const title="Bins"
const initialBin = {
  binCode: "",
  description: "",
  isActive: false,
  priority: "",
  locationCode: null,
};

export default function Bins() {
  const { settings } = React.useContext(SettingsContext);
  const { user } = React.useContext(AuthContext);
  const [loading, setLoading] = React.useState(false);
  const [mode, setMode] = React.useState("create");
  const [msg, setMsg] = React.useState(null);
  const [selectedBin, setSelectedBin] = React.useState(initialBin);
  const binCodeInputRef = React.useRef(null);
  const [modalIsOpen, setModalIsOpen] = React.useState(false)
  const queryClient = useQueryClient();
  const [binInfo, setBinInfo] = React.useState({totalBins: 0, activeBins: 0, availableBins: 0})
  const bannerVariantRef = React.useRef('info');
  const locationCodeRef = React.useRef(null);

  useEffect(() => {
    if(user && user?.locationCode) locationCodeRef.current = user.locationCode;
  }, [user])

  const { data: bins, isLoading, isError, error, refetch: refetchBins } = useQuery("bins", 
    async () => {
      let payload = {};
      if(locationCodeRef.current) payload = {locationCode: locationCodeRef.current};
      const response = await getBins(payload);
      return _.sortBy(response, ['desc'])
    }
  , {
    refetchOnWindowFocus: false, staleTime: 1000 * 60 * 5
  })

  useEffect(() => {
    console.log('* bins hook init');
    if(bins) {
      const availableBinsFiltered = bins.filter(bin => !bin.isActive);
      setBinInfo({
        totalBins: bins.length,
        availableBins: availableBinsFiltered.length 
      })

    }
  }, [bins])

  const showModal = (mode) => {
    // console.log("showModal mode", mode);
    setMode(mode);
    if (msg) setMsg(null);
    if (mode === "create") setSelectedBin(initialBin);
    setModalIsOpen(true)
  };

  const mutateBin = useMutation(async ({action, payload}) => {
    console.log("* mutateBin init");
    setLoading(true);
    console.log("[mutateBin] action: ", action, typeof action);
    console.log("[mutateBin] payload: ", payload);
    let result;
    if(window?.printflo_api) {
      try {
        result = await window.printflo_api[action](payload);
        // console.log("[mutateBin] result: ", result);
        if(_.isError(result)) throw result
      } catch (error) {
        console.log("[mutateBin:printflo_api] error: ", error);
        throw error
      }
    } else {
      try {
        action = _.replace(action, "_", "").replace("Bin", "");
        console.log("[mutateBin] action:replace ", action, typeof action);
        let url = `/api/bins/${action}`
        let response;
        if(action !== "delete") {
          response = await axios.post(url, payload)
        } else {
          response = await axios.delete(url, {data: payload})
        }
        result = response?.data
      } catch (error) {
        console.log("[mutateBin:axios] error: ", error);
        throw error
      }
    }
    return result
  }, {
    onError: (error) => {
      console.log("[mutateBin:onError] error: ", error);

      // let retval = errorHandler(error)
      setLoading(false);
      bannerVariantRef.current = "danger";
      if(error?.message) {
        setMsg(error.message);
        toast.info(error.message, {
          position: "bottom-right"
        })
      } 
    },
    onSuccess: (response) => {
      console.log("[mutateBin:onSuccess] response: ", response)
      setLoading(false);
      queryClient.invalidateQueries("bins");
    }
  })

  const submitHandler = () => {
    console.log("* submitHandler init");
    console.log("- mode", mode);
    console.log("- selectedBin", selectedBin);
    modalIsOpen && setModalIsOpen(false)
    msg && setMsg(null);
    bannerVariantRef.current = "info";

    let condition;
    if (mode === "edit" && _.has(selectedBin, "_id")) {
      condition = { _id: selectedBin._id };
    } else {
      let filter = {binCode: selectedBin?.binCode};
      if(settings?.useMultipleLocations) filter["locationCode"] = selectedBin?.locationCode;
      console.log("[submitHandler] filter: ", filter);
      if(_.findIndex(bins, filter) !== -1) {
        bannerVariantRef.current = "danger";
        setMsg("Bin code already exists")
        return;
      } 
      condition = { binCode: selectedBin.binCode };
      if(settings?.useMultipleLocations && selectedBin.locationCode) condition["locationCode"] = selectedBin?.locationCode;
    }

    if (selectedBin?.priority) {
      selectedBin.priority = parseInt(selectedBin.priority)
    }

    if (!_.isNil(selectedBin.binCode) && !_.isEmpty(selectedBin.binCode.trim())) {
      mutateBin.mutate({action: "_updateBin", payload: {condition, update: selectedBin}})
    } else {
      alert("Bin code is required");
      return
    }
  };

  const handleDelete = () => {
    console.log("== handleDelete init ==");
    console.log("- delete selectedBin._id", selectedBin._id);
    modalIsOpen && setModalIsOpen(false)
    mutateBin.mutate({action: "_deleteBin", payload: {_id: selectedBin._id}})
  }

  const exportBins = async () => {
    setLoading(true);
    // console.log(selectedExportMode);
    let clonedBins = _.cloneDeep(bins);
    const result = jsonToCSV({
      fields: ["binCode", "description", "loadCapacity", "priority", "isActive", "locationCode"],
      data: clonedBins
    });
    // console.log(result);

    const element = document.createElement("a");
    const file = new Blob([result], {
      type: "text/csv",
    });
    element.href = URL.createObjectURL(file);
    element.download = `bins_${moment().format("YYYYMMDDHHmm")}.csv`;
    document.body.appendChild(element); // Required for this to work in FireFox
    element.click();
    setLoading(false);
  };

  const importBins = (parsedData) => {
    console.log('* importBins init')
    setLoading(true);
    console.log("[importBins] parsedData:count", parsedData?.length);
    let tempBins = parsedData.map((bin) => {
      let isActive = bin.data.isActive;

      /^false/i.test(isActive) ? (isActive = false) : (isActive = true);
      return { ...bin.data, isActive };
    });

    // console.log("[importBins] tempBins: ", tempBins);
    let msg = `Total number of bins: ${tempBins.length}`;
    setMsg(msg);

    let i = 0;
    let len = tempBins.length - 1;

    async function loop() {
      try {
        let bin = tempBins[i];
        let binCode = bin.binCode;
        let locationCode = bin?.locationCode;
        // console.log(i, bin);
        const payload = {
          condition: { binCode },
          update: { ...bin },
        }

        if(!_.isNil(locationCode)) payload.condition["locationCode"] = locationCode;

        let result;
        if(window?.printflo_api) {
          result = await window.printflo_api._updateBin(payload);
        } else {
          const response = await axios.post("/api/bins/update", payload);
          result = response?.data;
        }

        setMsg(`${i + 1}/${tempBins.length}: ${result?.binCode} updated`);

        i += 1;

        if (i <= len && _.has(bin, "binCode")) {
          loop();
        } else {
          setMsg("* Completed import bins, click refresh to load a page");
          setLoading(false);
          return;
        }
      } catch (error) {
        console.log("importBins error", error);
        setMsg(error.response.data.toString());
      }
    }

    if (i <= len) {
      loop();
    }
  };

  const editBin = (bin) => {
    setSelectedBin(bin);
    setMode("edit");
    setModalIsOpen(true)
  };

  const resetBinsHandler = useMutation(async () => {
    console.log('* resetBinsHandler init')
    setLoading(true);
    let locationCode = locationCodeRef.current
    return await resetBins({locationCode});
  }, {
    onError: (error) => {
      let retval = errorHandler(error)
      setMsg(retval);
      setLoading(false);
    },
    onSuccess: (response) => {
      console.log("[resetBinsHandler:onSuccess] response: ", response)
      setLoading(false);
      toast.info(response?.message, {
        position: "bottom-right"
      })
      queryClient.invalidateQueries("bins");
    }
  });

  const batchDelete = (parsedData) => {
    console.log('* batchDelete init')
    try {
      setLoading(true);
      let temp = parsedData.map((item) => item.data);
      let msg = `Total number of bins for deleting: ${temp.length}`;
      setMsg(msg);
      let i = 0;
      let len = temp.length - 1;

      async function loop() {
        let { binCode, locationCode } = temp[i]
        let payload = { binCode }
        if(locationCode) payload["locationCode"] = locationCode;

        if(window?.printflo_api) {
          try {
            await window.printflo_api._deleteBin(payload)
          } catch (error) {
            console.log("batchDelete error", error);
            const retval = errorHandler(error);
            setLoading(false);
            setMsg(retval);
            return;
          }
        } else {
          try {
            await axios.delete("/api/bins/delete", {data: payload})
          } catch (error) {
            console.log("batchDelete error", error);
            const retval = errorHandler(error);
            setLoading(false);
            setMsg(retval);
            return;
          }
        }
        setMsg(`${i + 1}/${temp.length}: ${binCode} deleted.`);
        i += 1;
        if (i <= len && _.has(temp[i], "binCode")) {
          loop();
        } else {
          setMsg("* Completed batch deletion of the bins, click refresh to load a page.");
          setLoading(false);
          return;
        }
      }

      if (i <= len) {
        loop();
      }
    } catch (error) {
      const retval = errorHandler(error)
      console.log("- batchDelete error: ", retval);
      setMsg(retval);

    }
  }

  const onChangeLocationCodeHander = (v) => {
    console.log("* onChangeLocationCodeHander init");
    console.log("[onChangeLocationCodeHander] v: ", v);
    if(v==="all") v = null;
    locationCodeRef.current = v;
    console.log("[onChangeLocationCodeHander] locationCode: ", locationCodeRef);
    refetchBins();
  }

  return <>
      <Title title={title} />
      <PageMainHeader 
        title={title} 
        user={user} 
        settings={settings} 
      />
      <ToastContainer  theme='dark'/>
      <section className="primary">
        { isLoading ? (
          <Skeleton count={20} height={50} circle={true} />
        ) : isError ? (
          <Banner variant='danger'>{error?.message ? error.message : error}</Banner>
        ) : (
          null
        )}
        <PageMenuHeader>
          <MenuHeaderTemplate 
            showModal={showModal}
            importHandler={ importBins }
            exportHandler={ exportBins}
            batchDeleteHandler={batchDelete}
            handleDelete={handleDelete}
            selectedExportMode="all"
          />
          <Button
            variant="primary"
            className="swing-icon"
            leftGlyph={<FaSnowplow />}

            onClick={() => resetBinsHandler.mutate()}
          >
            Reset
          </Button>
          {(settings?.useMultipleLocations && settings?.locations) && (
            <div className="input-field location-container align-items-center">
              <label htmlFor="locationCode" className="mr-10">Location:</label>
              <Select
                value={locationCodeRef?.current ? locationCodeRef.current : 'all'}
                onChange={(value) => onChangeLocationCodeHander(value)}
                className="select-location"
                placeholder="Location Options"
                aria-labelledby="Location options"
              >
                <Option value="all">All</Option>
                {settings?.locations.map((location) => {
                  return (
                    <Option key={location?.code} value={location?.code}>
                      {location.name}
                    </Option>
                  );
                })}
              </Select>
            </div>
          )}
        </PageMenuHeader>
        {
          msg && <Banner className='mb-10' variant={bannerVariantRef.current}>{msg}</Banner>
        }
        {bins && Boolean(bins.length) ? (
          <>
            <Banner variant="info" className='mb-10'>
              <span className='inline-block mr-10'>Available Bins: <Badge variant="red">{binInfo.availableBins}</Badge></span>  
              <span className='inline-block mr-10'>Total Bins: <Badge variant="blue">{binInfo.totalBins}</Badge></span>
              <span className='inline-block mr-10'>Occupied(Active) Bins: <Badge variant="blue">{binInfo.totalBins - binInfo.availableBins}</Badge></span>  
            </Banner>

            <Table
              data={bins}
              columns={[
                <TableHeader label="Bin Code" sortBy={(datum) => datum.binCode}/>,
                <TableHeader label="Load Capacity" sortBy={(datum) => datum.loadCapacity}/>,
                <TableHeader label="Priority" sortBy={(datum) => datum.priority}/>,
                <TableHeader label="Description" sortBy={(datum) => datum.description}/>,
                <TableHeader label="Location" sortBy={(datum) => datum.locationCode} style={{display: !settings?.useMultipleLocations && 'none' }}/>,
                <TableHeader label="Active" sortBy={(datum) => datum.isActive}/>,
                <TableHeader label="Action" />,
              ]}
            >
              {
                ({datum: bin}) => (
                  <Row key={bin._id}>
                    <Cell>{bin.binCode}</Cell>
                    <Cell>{bin.loadCapacity}</Cell>
                    <Cell>{bin?.priority ? bin.priority : ""}</Cell>
                    <Cell>{bin.description ? bin.description : ""}</Cell>
                    <Cell style={{display: !settings?.useMultipleLocations && 'none' }}>{bin.locationCode ? bin.locationCode : ""}</Cell>
                    <Cell>{bin.isActive ? <FaCheck /> : ""}</Cell>
                    <Cell>{
                      <IconButton
                        aria-label="edit a bin"
                        onClick={() => editBin(bin)}
                        className='swing-icon'
                      >
                        <FaEdit />
                      </IconButton>}
                    </Cell>
                  </Row>
                )
              }
            </Table>
          </>
          
        ) : (
          <Banner>Bins not found.</Banner>
        )}
        <ModalBin 
          modalIsOpen={modalIsOpen}
          setModalIsOpen={setModalIsOpen}
          title={"Bin"}
          mode={mode}
          selectedBin={selectedBin}
          setSelectedBin={setSelectedBin}
          submitHandler={submitHandler}
          handleDelete={handleDelete}
          binCodeInputRef={binCodeInputRef}
          settings={settings}
          user={user}
        />
        <ScrollTop />
      </section>
      <ModalPreloader modalPreloaderIsOpen={loading} />
    </>
}
